import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { useEffect } from 'react'

import Redirect from 'helpers/redirect'
import { getAppRoute } from 'helpers/application'
import { getAppName } from 'models/application'

const Wrapper = ({ router, application }) => {
  const {
    query: { token, sdk, key },
  } = router

  useEffect(() => {
    if (token && sdk && key) {
      router.push(
        `${getAppRoute(application, 'url')}/deeplink/${token}?sdk=true`
      )
    } else {
      router.push(
        `${getAppRoute(application, 'as')}/events`,
        `${getAppRoute(application, 'url')}/events`
      )
    }
  }, [token, sdk, key, application])

  return <></>
}

Wrapper.propTypes = {
  router: PropTypes.object,
  application: PropTypes.object,
}

Wrapper.getInitialProps = async ctx => {
  const {
    query: { application, key },
  } = ctx

  if (!key && ctx.req) {
    const appName = getAppName(application)

    if (appName) {
      Redirect(`${getAppRoute(application, 'url')}/events`, ctx)
    }
  }

  return {}
}

export default withRouter(Wrapper)
